import React from "react";
import KC_Button from "../../designsystem/KC_Button/KC_Button";
import { tt } from "../../utils/i18n/i18n";

export type PlanFilterMode = "ambassador" | "loyalty";

interface Props {
  filterMode: PlanFilterMode;
  onFilterChange: (mode: PlanFilterMode) => void;
}

const WIDTH = 240;

export default function PlanFamilyFilter(props: Props) {
  return (
    <div className="d-flex flex-column flex-sm-row justify-content-center st-gap p-2">
      <KC_Button
        id="select-ambassador-btn"
        text={tt("ambassador")}
        isPrimary={props.filterMode === "ambassador"}
        isInverted={props.filterMode !== "ambassador"}
        isBordered={props.filterMode !== "ambassador"}
        onClick={() => props.onFilterChange("ambassador")}
        extraStyle={{ width: WIDTH }}
      />
      <KC_Button
        id="select-loyalty-btn"
        text={tt("loyalty")}
        isPrimary={props.filterMode === "loyalty"}
        isInverted={props.filterMode !== "loyalty"}
        isBordered={props.filterMode !== "loyalty"}
        onClick={() => props.onFilterChange("loyalty")}
        extraStyle={{ width: WIDTH }}
      />
    </div>
  );
}
